<template>
  <div class="loading-container">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'LoadingContainer',
}
</script>

<style lang="scss" scoped>
@import '@/assets/global-mixins.scss';

.loading-container {
  @include center-absolute-element;
}
</style>
